import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './TransferPanelPhone.module.css';

interface TransferNumberTabProps {
  isConferenceMode: boolean;
  onDialPhone: (phoneNumber: string) => void;
}

export function TransferNumberTab({ isConferenceMode, onDialPhone }: TransferNumberTabProps) {
  const { t } = useTranslation();
  const [phoneNumber, setPhoneNumber] = useState('');

  return (
    <div className={styles.phoneInput}>
      <label className={styles.phoneLabel}>{t('call:transfer.enterPhoneNumber')}</label>
      <input
        type="tel"
        className={styles.phoneField}
        value={phoneNumber}
        onChange={(e) => setPhoneNumber(e.target.value)}
        placeholder="+1 (555) 123-4567"
        onKeyDown={(e) => {
          if (e.key === 'Enter' && phoneNumber.trim()) {
            onDialPhone(phoneNumber);
          }
        }}
      />
      <button
        className={styles.dialButton}
        onClick={() => onDialPhone(phoneNumber)}
        disabled={!phoneNumber.trim()}
      >
        <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
          <path d="M20.01 15.38c-1.23 0-2.42-.2-3.53-.56a.977.977 0 00-1.01.24l-1.57 1.97c-2.83-1.35-5.48-3.9-6.89-6.83l1.95-1.66c.27-.28.35-.67.24-1.02-.37-1.11-.56-2.3-.56-3.53 0-.54-.45-.99-.99-.99H4.19C3.65 3 3 3.24 3 3.99 3 13.28 10.73 21 20.01 21c.71 0 .99-.63.99-1.18v-3.45c0-.54-.45-.99-.99-.99z" />
        </svg>
        {isConferenceMode ? t('call:transfer.addToCall') : t('call:actions.transfer')}
      </button>
    </div>
  );
}
